(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halo-purchase-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('halo-purchase')) {
    customElements.define('halo-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.button = this.querySelector('[data-purchase-submit]');
        this.status = this.querySelector('[data-purchase-status]');
        this.packs = [...this.querySelectorAll('[data-purchase-pack]')];
        this.lifecycle = (this.lifecycle || 0) + 1;
        this.busy = false;
        const choices = this.querySelectorAll('[data-pack-choice]');
        if (choices.length && !this.querySelector('[data-pack-choice]:checked')) choices[0].checked = true;
        this.querySelectorAll('[data-purchase-item]').forEach(item => this.updateItem(item));
        this.addEventListener('change', event => {
          if (event.target.matches('[data-purchase-variant]')) this.updateItem(event.target.closest('[data-purchase-item]'));
          this.status.textContent = '';
          this.update();
        }, { signal: this.controller.signal });
        this.addEventListener('input', event => {
          if (event.target.matches('[data-purchase-quantity]')) this.update();
        }, { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', event => {
          const pack = this.packs.find(pack => pack.dataset.blockId === event.detail?.blockId);
          const choice = pack?.querySelector('[data-pack-choice]');
          if (choice) { choice.checked = true; this.update(); }
        }, { signal: this.controller.signal });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, { signal: this.controller.signal });
        this.dataset.ready = '';
        this.update();
      }
      updateItem(item) {
        const variant = item.querySelector('[data-purchase-variant]').selectedOptions[0];
        const quantity = item.querySelector('[data-purchase-quantity]');
        if (variant && quantity.type === 'number') {
          quantity.min = variant.dataset.min;
          quantity.step = variant.dataset.increment;
          if (variant.dataset.max) quantity.max = variant.dataset.max;
          else quantity.removeAttribute('max');
          const value = Number(quantity.value);
          if (!this.validQuantity(value, variant.dataset)) quantity.value = variant.dataset.min;
        }
        const plans = item.querySelector('[data-purchase-plan]');
        if (plans) {
          const previous = plans.value;
          const template = [...item.querySelectorAll('[data-plan-options]')].find(template => template.dataset.planOptions === variant?.value);
          plans.replaceChildren(...(template ? template.content.cloneNode(true).children : []));
          if ([...plans.options].some(option => option.value === previous)) plans.value = previous;
        }
      }
      validQuantity(quantity, rule) {
        const min = Number(rule.min), increment = Number(rule.increment), max = Number(rule.max);
        return Number.isSafeInteger(quantity) && quantity >= min && increment > 0 && (!max || quantity <= max) && (quantity - min) % increment === 0;
      }
      state(pack) {
        const lines = [...pack.querySelectorAll('[data-purchase-item]')];
        if (!lines.length || pack.querySelector('[data-missing-product]')) return null;
        const grouped = new Map();
        let total = 0;
        for (const line of lines) {
          const variant = line.querySelector('[data-purchase-variant]').selectedOptions[0];
          const planSelect = line.querySelector('[data-purchase-plan]');
          const plan = planSelect?.selectedOptions[0];
          const quantity = Number(line.querySelector('[data-purchase-quantity]').value);
          if (!variant || variant.dataset.available !== 'true' || !/^\d+$/.test(variant.value)) return null;
          if (variant.dataset.requiresPlan === 'true' && !plan?.value) return null;
          if (planSelect && !plan) return null;
          if (plan?.value && !/^\d+$/.test(plan.value)) return null;
          const price = Number(plan ? plan.dataset.price : variant.dataset.price);
          if (!Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(quantity) || quantity < 1) return null;
          const key = variant.value + ':' + (plan?.value || '');
          const item = grouped.get(key) || { id: variant.value, quantity: 0, rule: variant.dataset };
          item.quantity += quantity;
          if (plan?.value) item.selling_plan = plan.value;
          grouped.set(key, item);
          total += price * quantity;
        }
        if (!Number.isSafeInteger(total) || [...grouped.values()].some(item => !this.validQuantity(item.quantity, item.rule))) return null;
        return { total, items: [...grouped.values()].map(({ rule, ...item }) => item) };
      }
      money(value) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol' }).format(value / 100);
      }
      update() {
        this.selected = this.packs.find(pack => !pack.querySelector('[data-pack-choice]') || pack.querySelector('[data-pack-choice]').checked);
        for (const pack of this.packs) {
          pack.dataset.selected = String(pack === this.selected);
          pack.querySelector('[data-pack-options]').disabled = this.busy || pack !== this.selected;
          const state = this.state(pack);
          const price = pack.querySelector('[data-pack-price]');
          if (price) price.textContent = state ? this.money(state.total) : this.dataset.unavailableLabel;
          pack.querySelectorAll('[data-purchase-item]').forEach(item => {
            const note = item.querySelector('[data-plan-note]');
            if (note) note.textContent = item.querySelector('[data-purchase-plan]').selectedOptions[0]?.dataset.description || '';
          });
        }
        this.querySelectorAll('[data-pack-choice]').forEach(choice => { choice.disabled = this.busy; });
        const state = this.selected && this.state(this.selected);
        this.button.disabled = this.busy || !state;
        this.button.textContent = this.busy ? this.dataset.loadingLabel : this.dataset.addLabel;
        this.querySelectorAll('[data-purchase-total]').forEach(total => { total.textContent = state ? this.money(state.total) : this.dataset.unavailableLabel; });
        this.querySelectorAll('[data-purchase-name]').forEach(name => { name.textContent = this.selected?.dataset.packName || ''; });
      }
      async submit() {
        const state = this.selected && this.state(this.selected);
        if (this.busy || !state || !this.form.reportValidity()) return;
        this.busy = true;
        this.update();
        this.status.textContent = this.dataset.loadingLabel;
        const lifecycle = this.lifecycle;
        const request = this.request = new AbortController();
        const timer = setTimeout(() => request.abort(), 15000);
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: state.items }), signal: request.signal });
          const data = await response.json().catch(() => null);
          if (!response.ok) throw new Error(typeof data?.description === 'string' ? data.description : this.dataset.errorLabel);
          if (!Array.isArray(data?.items) || !data.items.length) throw new Error(this.dataset.uncertainLabel);
          if (this.isConnected && this.lifecycle === lifecycle) window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (this.isConnected && this.lifecycle === lifecycle) {
            this.status.textContent = (error.name === 'AbortError' || error instanceof TypeError ? this.dataset.uncertainLabel : error.message) || this.dataset.errorLabel;
            this.busy = false;
            this.update();
          }
        } finally { clearTimeout(timer); }
      }
      disconnectedCallback() {
        this.lifecycle = (this.lifecycle || 0) + 1;
        this.controller?.abort();
        this.request?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halo-signup-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('halo-signup-form')) {
    customElements.define('halo-signup-form', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.lifecycle = (this.lifecycle || 0) + 1;
        this.submitting = false;
        this.form = this.querySelector('[data-hsf-form]');
        if (!this.form) return;
        this.email = this.form.querySelector('input[type="email"]');
        this.widget = this.querySelector('[data-hsf-turnstile]');
        if (this.widget) this.email?.addEventListener('focus', () => this.ensureTurnstile(), { once: true, signal: this.controller.signal });
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.lifecycle = (this.lifecycle || 0) + 1;
        if (this.widgetId != null && window.turnstile?.remove) window.turnstile.remove(this.widgetId);
        this.widgetId = null;
        this.widgetPending = null;
      }
      status(message) { const status = this.querySelector('[data-hsf-status]'); if (status) { status.hidden = false; status.textContent = message; } }
      async ensureTurnstile() {
        if (!this.widget || this.widgetId != null || this.widgetFailed) return;
        if (this.widgetPending) return this.widgetPending;
        const lifecycle = this.lifecycle;
        this.widgetPending = (async () => {
          try {
            await this.constructor.loadTurnstile();
            if (!this.isConnected || this.lifecycle !== lifecycle) return;
            this.widgetId = window.turnstile.render(this.widget, { sitekey: this.widget.dataset.sitekey, callback: token => { this.form.elements.turnstileToken.value = token; }, 'expired-callback': () => { this.form.elements.turnstileToken.value = ''; window.turnstile.reset(this.widgetId); }, 'error-callback': () => { this.form.elements.turnstileToken.value = ''; this.widgetFailed = true; this.status(this.dataset.errorTurnstile); } });
          } catch (_) { if (this.isConnected && this.lifecycle === lifecycle) { this.widgetFailed = true; this.status(this.dataset.errorTurnstile); } }
          finally { if (this.lifecycle === lifecycle) this.widgetPending = null; }
        })();
        return this.widgetPending;
      }
      async submit(event) {
        const provider = this.dataset.provider;
        if (provider === 'shopify' || provider === 'mailchimp') return;
        event.preventDefault();
        if (this.form.elements.website?.value) return;
        if (this.submitting) return;
        const lifecycle = this.lifecycle;
        const button = this.form.querySelector('[type="submit"]');
        this.submitting = true;
        button.disabled = true;
        try {
          if (this.widget) {
            await this.ensureTurnstile();
            if (this.widgetFailed || !this.form.elements.turnstileToken?.value) { this.status(this.dataset.errorTurnstile); return; }
          }
          if (!this.isConnected || this.lifecycle !== lifecycle) return;
          const data = new FormData(this.form);
          let response;
          const signal = AbortSignal.timeout(12000);
          if (provider === 'loops') response = await fetch(this.form.action, { method: 'POST', body: new URLSearchParams(data), headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }, signal });
          else response = await fetch(this.form.action, { method: 'POST', body: JSON.stringify(Object.fromEntries(data)), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal, credentials: 'omit' });
          const result = await response.json().catch(() => ({}));
          if (!response.ok || result.success !== true) throw new Error(result.error || result.message || this.dataset.errorSubmit);
          if (!this.isConnected || this.lifecycle !== lifecycle) return;
          this.form.querySelector('[data-hsf-fields]').hidden = true; this.status(this.dataset.successMessage);
          this.dispatchEvent(new CustomEvent('halo:signup-success', { bubbles: true }));
        } catch (error) {
          if (!this.isConnected || this.lifecycle !== lifecycle) return;
          if (this.widgetId != null && window.turnstile?.reset) { this.form.elements.turnstileToken.value = ''; window.turnstile.reset(this.widgetId); }
          this.status(error.name === 'TimeoutError' ? this.dataset.errorNetwork : (error.message || this.dataset.errorSubmit));
        } finally { if (this.lifecycle === lifecycle) { this.submitting = false; if (button && this.isConnected) button.disabled = false; } }
      }
      static loadTurnstile() {
        if (window.turnstile) return Promise.resolve();
        if (this.turnstilePromise) return this.turnstilePromise;
        this.turnstilePromise = new Promise((resolve, reject) => { const script = document.createElement('script'); const timer = setTimeout(() => { script.remove(); reject(new Error('Verification unavailable')); }, 12000); script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; script.async = true; script.onload = () => { clearTimeout(timer); window.turnstile ? resolve() : reject(new Error('Verification unavailable')); }; script.onerror = () => { clearTimeout(timer); reject(new Error('Verification unavailable')); }; document.head.append(script); });
        return this.turnstilePromise;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
